// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.photo[data-v-2bc78b2b] {\n\tposition:relative;\n\tdisplay: inline-block;\n\tmax-height: 200px;\n}\n.photo>*[data-v-2bc78b2b]:first-child {\n\tmax-height:200px;\n\theight:100%;\n\tmax-width: 100%;\n\t-o-object-fit: cover;\n\t   object-fit: cover;\n}\n.photo>.close-button[data-v-2bc78b2b] {\n\tposition:absolute;\n\ttop: 5px;\n\tright:5px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
